import React, { Component } from "react";
import { Table } from "reactstrap";
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { Button } from '../../../components';
import{getBrands} from '../../../actions/brandActions';
import ReactPaginate from 'react-paginate';
class Brands extends Component {
  state = {
    brandsLoading:false,
    isMounted: false,
    skip: 0,
    limit:12
  };
  componentDidMount = () => {
    this.setState({ isMounted: true }, () => {
      if (this.state.isMounted) {
        this.setState({ isMounted: false });
    {this.props.onGetBrands(this.state.skip,this.state.limit)}
  }
  });
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let skip = selected * this.state.limit
    this.setState({skip: skip});
    this.props.onGetBrands(skip,this.state.limit);
  }

  getLoder = () =>{
    let classes = "bt-loader ";
    classes += this.props.brandsLoading ? 'bt-show' : 'bt-hide';
    return classes;
  }

  render() {
    const {brands} = this.props;
    return (
      <div>
        <div className="content">
        <div className={this.getLoder()}></div>
          <div className="table-product-wrapper">
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>BRAND NAME</th>
                  <th>BRAND CODE</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {brands.length > 0 ? brands.map((brand,index) => (
                  <tr key={brand.id}>
                  <td>
                    {index+1 + this.state.skip }
                  </td>
                    <td className="nameImg">
                      <img src={brand.logo} alt="wild" className="img-ico" />
                      <span className="p-name">{brand.name} </span>
                    </td>
                    <td>
                      {brand.code}
                    </td>
                    <td>
                      <div className="group-action">
                        <Link className="btn" to={`/admin/edit-brand/${brand.id}`}>
                          <i className="ico icon-edit" />
                        </Link>
                        {/* <button className="btn">
                          <i className="ico icon-delete" />
                        </button> */}
                      </div>
                    </td>
                  </tr>
                )):<tr><td colSpan={'4'}>No data found</td></tr>}
              </tbody>
            </Table>
          </div>
          <Button className="fixed-yellow"  onClick={() => this.props.history.push("/admin/add-brand")}>Add</Button>
          <div className="pagination-wrapper">
        <ReactPaginate previousLabel={<i className="fas fa-angle-left"></i>}
        nextLabel={<i className="fas fa-angle-right"></i>}
        pageLinkClassName={"page-link"}
        breakClassName={"break-me"}
        pageCount={Math.ceil(this.props.count/this.state.limit)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={this.handlePageClick}
        containerClassName={"pagination"}
        pageClassName={"page-item"}
        activeClassName={"active"} />
        </div>
        </div>
      </div>
    );
  }
}


Brands.defaultProps = {
  brands : []
}

const mapStateToProps = (state) => ({
  brandsLoading:state.brandReducer.brandsLoading,
  brands: state.brandReducer.brands,
  count:state.brandReducer.count,
})

const mapDispatchToProps = (dispatch)=> ({
  onGetBrands:(skip,take)=>{
    dispatch(getBrands(skip,take))
  }
})
export default connect(mapStateToProps, mapDispatchToProps)(Brands)
